<template>
    <div id="data-sources">
        <status-message></status-message>
        <div class="lists-header td-flex">
            <h1 class="td-h2">Data Sources</h1>
            <button class="td-btn primary slim icon-left" title="View" @click.prevent="openAddModal">
                <icon type="solid" name="faPlus" aria-hidden="true"></icon> Add New
            </button>
        </div>
        <div class="mb-4 td-banner info">
            <icon type="solid" name="faInfoCircle" aria-hidden="true"></icon>
            <p class="ma-0 mb-1">This page contains Data Sources for locations that were manually added by our team using publicly available information (e.g., Campgrounds). If a location was not created manually, this page will not contain any sources.</p>
            <p class="ma-0">Manually added listings may have limited contact details and no associated users, and the customer may be unaware of their existence. The Data Sources field shows where the information was obtained at the time of creation.</p>
        </div>
        <div class="data-sources td-table-container mt-0" v-if="dataSources && dataSources.length > 0">
            <table cellspacing="0" cellpadding="0" class="td-table">
                <thead>
                    <tr class="table-header">
                        <th>Source Name</th>
                        <th>Website Address</th>
                        <th>Key</th>
                        <th class="td-text-right"></th>
                    </tr>
                </thead>
                <tbody v-if="!isLoading && dataSources.length > 0" class="rows-container">
                    <tr class="table-row main-row" v-for="(dataSource, index) in dataSources" :key="dataSource.id">
                        <td class="name">
                            <h2 class="td-h5 mt-0">
                                {{ dataSource.source }}
                            </h2>
                        </td>
                        <td class="id">
                            <a :href="dataSource.website" title="Website Address" target="_blank">{{ dataSource.websiteAddress }}</a>
                        </td>
                        <td class="key">
                            {{ dataSource.key }}
                        </td>

                        <td class="table-actions">
                            <div class="td-flex">
                                <button class="td-btn secondary-outlined slim icon-left" title="View" @click.prevent="openEditModal(dataSource)">
                                    <icon type="solid" name="faPen" aria-hidden="true"></icon> Edit
                                </button>
                                <button class="td-btn danger slim icon-left" title="View" @click.prevent="openDeleteModal(dataSource)">
                                    <icon type="solid" name="faTrash" aria-hidden="true"></icon> Delete
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
                <tbody v-if="isLoading">
                    <tr><th colspan="5"><div class="loading"><icon name="faSpinner" type="solid" spin></icon></div></th></tr>
                </tbody>
            </table>
        </div>
    </div>
    <div v-if="dataSources && dataSources.length < 1 && !isLoading" class="td-banner warning no-icon mt-2">
        <p>No data sources found.</p>
    </div>
    <modal @close="closeDeleteModal" style="max-width:800px;height:auto" v-if="showDeleteModal" class="delete-modal">
        <template #header>
            <h4 class="td-h4">Delete Data Source</h4>
        </template>
        <p class="my-2">Are you sure you want to remove this data source?</p>
        <template #footer>
            <div class="actions">
                <button class="td-btn btn secondary-outlined" title="Cancel Delete" @click="closeDeleteModal">Cancel</button>
                <button class="danger td-btn" title="Delete Data Source" @click="confirmDelete">Delete</button>
            </div>
        </template>
    </modal>
    <modal @close="closeEditModal" style="max-width:800px;height:auto" v-if="showEditModal || showAddModal" class="list-modal">
        <template #header>
            <h4 class="td-h4"><span v-if="showEditModal">Edit</span><span v-else>Add</span> Data Source</h4>
        </template>

        <div class="my-2">
            <label class="td-label">Name:</label>
            <input :class="[{'error': dataSourceValidator.errors['source']}, 'td-input']"
                   v-model="editedSource.source" type="text" placeholder="Source Name"  
                   @input="dataSourceValidator.validate('source')" />
            <error v-if="dataSourceValidator.errors['source']" :error="dataSourceValidator.errors['source']"></error>
        </div>
        <div class="my-2">
            <label class="td-label">Website:</label>
            <input :class="[{'error': dataSourceValidator.errors['website']}, 'td-input']" type="text" 
                   placeholder="Source Website" v-model="editedSource.websiteAddress" 
                   @input="dataSourceValidator.validate('website')"/>
            <error v-if="dataSourceValidator.errors['website']" :error="dataSourceValidator.errors['website']"></error>
        </div>
        <div class="my-2">
            <label class="td-label">Key:</label>
            <input :class="[{'error': dataSourceValidator.errors['key']}, 'td-input']"
                   v-model="editedSource.key" type="text" placeholder="Data Source Key" 
                   @input="dataSourceValidator.validate('key')"/>
            <error v-if="dataSourceValidator.errors['key']" :error="dataSourceValidator.errors['key']"></error>
        </div>
        <template #footer>
            <div class="actions">
                <button class="td-btn btn secondary-outlined" title="Cancel Edit Network List" @click="closeEditModal">Cancel</button>
                <button class="secondary td-btn" title="Edit Network List" @click="confirmSave">Save</button>
            </div>
        </template>
    </modal>
</template>

<script>
    import script from './DataSources';
    export default script;</script>

<style lang="less">
    @import "./DataSources.less";
</style>